import { useAppSelector } from '@src/core/hooks';
import { errorsSelector } from '@src/features/customers/auth/store/auth';
import { getErrorMessage } from '@src/common';

/** Error message for a field (`name`) within a context of the auth store. */
export function useFieldError(context: string | undefined, name: string) {
  const errors = useAppSelector(errorsSelector);
  return getErrorMessage(errors[context!], name);
}
